import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import AuthService from '../../services/AuthService'; 
import { Toast } from 'primereact/toast';
import LeadService from '../../services/LeadService';
import ToastService from '../../services/ToastService';
import { property } from 'lodash';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}


function EditLead() {
  const queryParam = useQuery();
  const toast = useRef(null);
  const { id } = useParams();  
  const navigate = useNavigate();
  const toastService = new ToastService(toast); 
  const [UserId] = useState(() => AuthService.resolveScopedUserId(queryParam.get("userId")));
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    startDate:"",
    endDate:"",
    address:"",
    property:"",
    source:"",
    userId: UserId,
    id: id,
    clientId:""
  });
  const [formError, setFormError] = useState({}); 
  useEffect(() => {
    const fetchLeadsData = async () => {
      try {
        const data = await LeadService.getLeadById(id);
        setForm(data);
      } catch (error) {
        console.error('Error fetching leads data:', error);
      } 
    };
    fetchLeadsData();
  }, [id]);
  
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setForm(prevForm => ({ ...prevForm, [name]: value }));
  };
  
  const validateForm = () => {
    const errors = {};
    if (!form.firstName.trim()) errors.firstName = "Please enter the lead first name.";
    if (!form.email.trim()) errors.email = "Please enter the email.";
    if (!form.address.trim()) errors.address = "Please enter address.";
    if (!form.contactNumber) errors.contactNumber = "Please enter the contact number.";
    if (!form.startDate) errors.startDate = "Please enter the start date.";
    if (!form.endDate) errors.endDate = "Please enter the endDate .";
    setFormError(errors);
    if (Object.keys(errors).length > 0) {
      toastService.showWarning('Validation Error', 'Please fill out all required fields');
    }
    return Object.keys(errors).length === 0;
  };

  const onLeadSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    updateLead();
  };

  const updateLead = async () => {
    const formDataToSend = new FormData();
    Object.keys(form).forEach(key => {
          formDataToSend.append(key, form[key]);
        }
      );
    try {
      await LeadService.updateLead(id, formDataToSend); 
      toastService.showSuccess('Success', 'Lead updated successfully');
      setTimeout(() => {
      //  navigate("/leads");
        navigate(-1);
      }, 1000); 
    } catch (error) {
      console.error("Error updating lead:", error);
      toastService.showError('Error', 'Failed to update lead');
    }
  };
  const labelSt = {
    display: 'block', fontSize: '12px', fontWeight: '600',
    color: '#8392ab', marginBottom: '6px',
    textTransform: 'uppercase', letterSpacing: '0.05em',
  };
  const inputSt = (err, disabled) => ({
    width: '100%', padding: '10px 14px',
    border: `1.5px solid ${err ? '#f5365c' : disabled ? '#f0f2f5' : '#e9ecef'}`,
    borderRadius: '10px', fontSize: '14px',
    color: disabled ? '#adb5bd' : '#344767',
    background: disabled ? '#f8f9fe' : '#fff',
    outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s',
    cursor: disabled ? 'not-allowed' : 'text',
  });
  const errSt = { fontSize: '11px', color: '#f5365c', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' };

  const SecHead = ({ color, icon, title }) => (
    <div style={{ paddingBottom: '10px', borderBottom: '1.5px solid #f0f2f5', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
      <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', color, fontSize: '13px' }}>
        <i className={`fas ${icon}`} />
      </div>
      <p style={{ fontSize: '13px', fontWeight: '700', color: '#344767', textTransform: 'uppercase', letterSpacing: '0.06em', margin: 0 }}>{title}</p>
    </div>
  );

  return (
    <div style={{ padding: '24px', minHeight: '100vh', background: '#f4f6fb' }}>
      <Toast ref={toast} />
      <style>{`
        .el-input:focus { border-color: #344767 !important; box-shadow: 0 0 0 3px rgba(52,71,103,0.1) !important; }
        .el-submit-btn:hover { opacity: 0.88; transform: translateY(-1px); }
        .el-back-btn:hover { background: #f0f2f5 !important; }
      `}</style>

      {/* Page Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '12px',
            background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: '20px', boxShadow: '0 4px 12px rgba(52,71,103,0.3)',
          }}>
            <i className="fas fa-user-edit" />
          </div>
          <div>
            <p style={{ fontSize: '22px', fontWeight: '700', color: '#344767', margin: 0, lineHeight: 1.2 }}>
              Edit Lead
            </p>
            <p style={{ fontSize: '13px', color: '#8392ab', margin: 0, marginTop: '2px' }}>
              Update lead details — Lead ID #{id}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="el-back-btn"
          onClick={() => navigate(-1)}
          style={{
            background: '#fff', border: '1.5px solid #e9ecef',
            borderRadius: '10px', padding: '9px 20px',
            fontSize: '13px', fontWeight: '600', color: '#525f7f',
            cursor: 'pointer', display: 'flex', alignItems: 'center',
            gap: '7px', transition: 'all 0.2s',
          }}
        >
          <i className="fas fa-arrow-left" />
          Back
        </button>
      </div>

      {/* Lead identity banner */}
      {form.firstName && (
        <div style={{
          background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
          borderRadius: '16px', padding: '18px 24px', marginBottom: '24px',
          display: 'flex', alignItems: 'center', gap: '16px',
          boxShadow: '0 4px 20px rgba(52,71,103,0.2)',
        }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '50%', flexShrink: 0,
            background: 'rgba(255,255,255,0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: '18px', fontWeight: '700',
          }}>
            {(form.firstName || '?')[0].toUpperCase()}
          </div>
          <div>
            <p style={{ color: '#fff', fontWeight: '700', fontSize: '16px', margin: 0 }}>
              {form.firstName} {form.lastName}
            </p>
            <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '13px', margin: 0 }}>
              {form.email || 'No email'} &nbsp;·&nbsp; {form.contactNumber || 'No contact'}
            </p>
          </div>
          {form.source && (
            <span style={{
              marginLeft: 'auto', background: 'rgba(255,255,255,0.15)',
              color: '#fff', borderRadius: '20px', padding: '4px 14px',
              fontSize: '12px', fontWeight: '600',
            }}>
              <i className="fas fa-link" style={{ marginRight: '6px' }} />{form.source}
            </span>
          )}
        </div>
      )}

      <form onSubmit={onLeadSubmit}>
        <div style={{ background: '#fff', borderRadius: '20px', boxShadow: '0 4px 24px rgba(52,71,103,0.08)', overflow: 'hidden' }}>

          {/* Gradient strip */}
          <div style={{
            background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
            padding: '20px 28px', display: 'flex', alignItems: 'center', gap: '10px',
          }}>
            <i className="fas fa-id-card" style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px' }} />
            <span style={{ color: '#fff', fontWeight: '600', fontSize: '15px' }}>Lead Information</span>
          </div>

          <div style={{ padding: '32px 28px' }}>

            {/* Section 1 – Personal */}
            <div style={{ marginBottom: '28px' }}>
              <SecHead color="#5e72e4" icon="fa-user" title="Personal Details" />
              <div className="row g-3">
                {[
                  { label: 'First Name', name: 'firstName', type: 'text', required: true },
                  { label: 'Last Name', name: 'lastName', type: 'text' },
                  { label: 'Email Address', name: 'email', type: 'email', required: true },
                ].map(({ label, name, type }) => (
                  <div className="col-md-4" key={name}>
                    <label style={labelSt} htmlFor={name}>{label}</label>
                    <input
                      type={type} id={name} name={name}
                      className="el-input"
                      style={inputSt(!!formError[name], false)}
                      placeholder={label}
                      value={form[name] || ''}
                      onChange={changeHandler}
                    />
                    {formError[name] && <p style={errSt}><i className="fas fa-exclamation-circle" />{formError[name]}</p>}
                  </div>
                ))}
              </div>
            </div>

            {/* Section 2 – Contact & Source */}
            <div style={{ marginBottom: '28px' }}>
              <SecHead color="#2dce89" icon="fa-phone-alt" title="Contact & Source" />
              <div className="row g-3">
                <div className="col-md-4">
                  <label style={labelSt} htmlFor="contactNumber">Contact Number</label>
                  <input
                    type="text" id="contactNumber" name="contactNumber"
                    className="el-input"
                    style={inputSt(!!formError.contactNumber, false)}
                    placeholder="Contact Number"
                    value={form.contactNumber || ''}
                    onChange={changeHandler}
                    maxLength="13"
                  />
                  {formError.contactNumber && <p style={errSt}><i className="fas fa-exclamation-circle" />{formError.contactNumber}</p>}
                </div>
                <div className="col-md-4">
                  <label style={labelSt} htmlFor="source">Source</label>
                  <input
                    type="text" id="source" name="source"
                    className="el-input"
                    style={inputSt(!!formError.source, false)}
                    placeholder="e.g. Facebook, 99acres, Website"
                    value={form.source || ''}
                    onChange={changeHandler}
                  />
                  {formError.source && <p style={errSt}><i className="fas fa-exclamation-circle" />{formError.source}</p>}
                </div>
                <div className="col-md-4">
                  <label style={labelSt} htmlFor="property">Property Interest</label>
                  <input
                    type="text" id="property" name="property"
                    className="el-input"
                    style={inputSt(!!formError.property, false)}
                    placeholder="Property"
                    value={form.property || ''}
                    onChange={changeHandler}
                  />
                  {formError.property && <p style={errSt}><i className="fas fa-exclamation-circle" />{formError.property}</p>}
                </div>
              </div>
            </div>

            {/* Section 3 – Dates & Location */}
            <div style={{ marginBottom: 0 }}>
              <SecHead color="#fb6340" icon="fa-calendar-alt" title="Dates & Location" />
              <div className="row g-3">
                <div className="col-md-4">
                  <label style={labelSt} htmlFor="startDate">
                    Start Date
                    <span style={{ marginLeft: '6px', fontSize: '10px', color: '#adb5bd', textTransform: 'none', letterSpacing: 0 }}>(read-only)</span>
                  </label>
                  <input
                    type="datetime-local" id="startDate" name="startDate"
                    style={inputSt(!!formError.startDate, true)}
                    value={form.startDate || ''}
                    onChange={changeHandler}
                    disabled
                  />
                  {formError.startDate && <p style={errSt}><i className="fas fa-exclamation-circle" />{formError.startDate}</p>}
                </div>
                <div className="col-md-4">
                  <label style={labelSt} htmlFor="endDate">
                    End Date
                    <span style={{ marginLeft: '6px', fontSize: '10px', color: '#adb5bd', textTransform: 'none', letterSpacing: 0 }}>(read-only)</span>
                  </label>
                  <input
                    type="datetime-local" id="endDate" name="endDate"
                    style={inputSt(!!formError.endDate, true)}
                    value={form.endDate || ''}
                    onChange={changeHandler}
                    disabled
                  />
                  {formError.endDate && <p style={errSt}><i className="fas fa-exclamation-circle" />{formError.endDate}</p>}
                </div>
                <div className="col-md-4">
                  <label style={labelSt} htmlFor="address">Address</label>
                  <input
                    type="text" id="address" name="address"
                    className="el-input"
                    style={inputSt(!!formError.address, false)}
                    placeholder="Full Address"
                    value={form.address || ''}
                    onChange={changeHandler}
                  />
                  {formError.address && <p style={errSt}><i className="fas fa-exclamation-circle" />{formError.address}</p>}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{
            padding: '20px 28px', background: '#f8f9fe',
            borderTop: '1.5px solid #f0f2f5',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px',
          }}>
            <span style={{ fontSize: '13px', color: '#8392ab', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="fas fa-info-circle" style={{ color: '#5e72e4' }} />
              Fields marked with a lock are system-generated and cannot be edited
            </span>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                type="button"
                onClick={() => navigate(-1)}
                style={{
                  background: 'transparent', border: '1.5px solid #e9ecef',
                  borderRadius: '10px', padding: '10px 24px',
                  fontSize: '14px', fontWeight: '600', color: '#8392ab',
                  cursor: 'pointer', transition: 'all 0.2s',
                }}
              >
                <i className="fas fa-times" style={{ marginRight: '7px' }} />Cancel
              </button>
              <button
                type="submit"
                className="el-submit-btn"
                style={{
                  background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
                  border: 'none', borderRadius: '10px', padding: '10px 32px',
                  fontSize: '14px', fontWeight: '700', color: '#fff',
                  cursor: 'pointer', boxShadow: '0 4px 15px rgba(52,71,103,0.3)',
                  display: 'flex', alignItems: 'center', gap: '8px', transition: 'all 0.2s',
                }}
              >
                <i className="fas fa-save" />
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditLead;